import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography, Pagination } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const AdminWorkoutsReviewBlock = ({ workouts, onReviewWorkout }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const workoutsPerPage = 10;

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * workoutsPerPage;
  const endIndex = startIndex + workoutsPerPage;
  const paginatedWorkouts = workouts.slice(startIndex, endIndex);

  return (
    <Box>
      {paginatedWorkouts.map((workout) => (
        <Box key={workout.id} padding={2} border={1} marginBottom={2} borderRadius={2}>
          <Typography variant="h6">{workout.name}</Typography>
          <Typography variant="body2">{workout.description}</Typography>
          <Typography variant="body2">Category: {workout.categoryName}</Typography>
          <Typography variant="body2">Is Reviewed: </Typography><CheckIcon color={workout.isReviewed ? 'primary' : 'disabled'} />
          <Typography variant="body2">Is Approved: </Typography><CloseIcon color={workout.isApproved ? 'primary' : 'disabled'} />
          <Box display="flex" gap={1} marginTop={2}>
            <Button
              variant="contained"
              color="success"
              disabled={workout.isReviewed}
              onClick={() => onReviewWorkout({ ...workout, isApproved: true })}
            >
              Approve
            </Button>
            <Button
              variant="contain  ed"
              color="error"
              disabled={workout.isReviewed}
              onClick={() => onReviewWorkout({ ...workout, isApproved: false })}
            >
              Deny
            </Button>
          </Box>
        </Box>
      ))}
      <Pagination
        count={Math.ceil(workouts.length / workoutsPerPage)}
        page={currentPage}
        onChange={handlePageChange}
        sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}
      />
    </Box>
  );
};

AdminWorkoutsReviewBlock.propTypes = {
  workouts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      equipmentNeeded: PropTypes.bool.isRequired,
      categoryName: PropTypes.string.isRequired,
      isReviewed: PropTypes.bool.isRequired,
      isApproved: PropTypes.bool.isRequired,
    })
  ).isRequired,
  onReviewWorkout: PropTypes.func.isRequired,
};

export default AdminWorkoutsReviewBlock;
